var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61515_12785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 9.16797H3.33333C2.8731 9.16797 2.5 9.54106 2.5 10.0013V17.5013C2.5 17.9615 2.8731 18.3346 3.33333 18.3346H16.6667C17.1269 18.3346 17.5 17.9615 17.5 17.5013V10.0013C17.5 9.54106 17.1269 9.16797 16.6667 9.16797Z",
    stroke: "#7897F2",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 9.16797V5.83464C5.83301 3.53345 7.69851 1.66797 9.99967 1.66797C12.3008 1.66797 14.1663 3.53345 14.1663 5.83464V9.16797",
    stroke: "#7897F2",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5V15",
    stroke: "#7897F2",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61515_12785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/Frame (3).0b76088a6f4fdca96bd87abb91359851.svg";
export { ForwardRef as ReactComponent };